import { render, staticRenderFns } from "./ItemSelect.vue?vue&type=template&id=5c3c1f70&"
import script from "./ItemSelect.vue?vue&type=script&lang=js&"
export * from "./ItemSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports